import React from 'react';

const Paragraph = ({ 
    children, 
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <p className={className} style={style} {...props}>
            {children}
        </p>
    );
};

export default Paragraph;

